export default "__VITE_ASSET__DRVel5Zx__"